export default {
	changePassword: {
		'Change Password': '修改密码',
		'Set Password': '设置密码',
	},
	profile: {
		enter_phone_number: '请输入手机号',
		please_select: '请选择',
		绑定手机号: '绑定手机号',
		绑定邮箱: '绑定邮箱',
		裁剪人脸: '裁剪人脸照片',
		裁剪要求: '裁剪要求',
		查看认证信息: '查看',
		查看原因: '查看原因',
		城市: '城市',
		待审核: '待审核',
		当前: '当前',
		当前尺寸: '当前尺寸',
		地址: '地址',
		点击认证: '点击认证',
		二要素认证: '二要素认证',
		二要素说明: '校验姓名与身份证号是否一致',
		放大: '放大',
		分辨率太低: '分辨率太低，至少需要 480 × 640 像素',
		更换手机号: '更换手机号',
		更换邮箱: '更换邮箱',
		公司名称: '公司名称',
		'国家/地区': '国家/地区',
		基本信息: '基本信息',
		仅支持jpg_png_webp: '仅支持 jpg / png / webp 格式',
		仅支持PNG_JPG_JPEG: '仅支持 PNG / JPG / JPEG 格式',
		拒绝原因: '拒绝原因',
		开始扫脸认证: '开始扫脸认证',
		请上传人脸图片: '请上传人脸图片',
		请填写18位身份证号: '请填写身份证号',
		请填写本人实名手机号: '请填写本人实名手机号',
		请填写有效的11位手机号: '请填写有效的11位手机号',
		请填写有效的18位身份证号: '请填写有效的18位身份证号',
		请填写有效的手机号: '请填写有效的手机号',
		请填写真实姓名: '请填写真实姓名',
		去认证: '去认证',
		人脸说明: '请上传 PNG / JPG / JPEG 格式的本人正面照，光线充足、无遮挡；裁剪后会按 3:4 竖版输出，自动压缩到 1MB 以内',
		人脸图片: '人脸图片',
		认证成功: '认证成功',
		认证类型: '认证类型',
		认证失败: '认证失败',
		认证信息: '认证信息',
		若窗口未自动打开请点击: '若窗口未自动打开请点击',
		三要素认证: '三要素认证',
		三要素说明: '校验姓名、身份证号、手机号是否一致',
		扫脸初始化失败: '扫脸初始化失败',
		扫脸认证: '扫脸认证',
		扫脸说明: '点击下方按钮，将在新窗口打开阿里云扫脸页面，完成后回到此页点击"我已完成扫脸"',
		扫脸跳转说明: '已在新窗口打开扫脸页面，完成后回到此处点击"我已完成扫脸"',
		上传失败: '上传失败',
		身份证号: '身份证号',
		审核不通过: '审核不通过',
		审核中提示: '资料审核中，请耐心等待审核',
		实名认证: '实名认证',
		实名认证信息: '实名认证信息',
		实时预览: '实时预览',
		手动打开扫脸页面: '手动打开扫脸页面',
		手机号: '手机号',
		缩小: '缩小',
		提升认证等级: '点击提升',
		图片不能超过4MB: '图片不能超过 4MB',
		图片仍超过1MB请重新裁剪: '裁剪后图片仍超过 1MB，请重新裁剪缩小范围',
		未绑定: '未绑定',
		未认证: '未认证',
		未填写: '未填写',
		我已完成扫脸: '我已完成扫脸',
		无拒绝原因: '管理员未填写拒绝原因',
		姓名: '姓名',
		修改基本信息: '修改基本信息',
		修改信息: '修改信息',
		要求: '要求',
		要求_大小: '裁剪后体积自动压到 1MB 以内',
		要求_分辨率: '分辨率 480×640 ~ 1080×1920',
		要求_格式: '格式：PNG / JPG / JPEG',
		要求_竖版: '高 > 宽（3:4 竖版自动锁定）',
		已绑定: '已绑定',
		已认证: '已认证',
		邮箱: '邮箱',
		邮箱更换成功提示: '邮箱更换成功，点击“确定”刷新页面',
		邮箱未绑定: '邮箱未绑定',
		邮箱已绑定: '邮箱已绑定',
		邮政编码: '邮政编码',
		右转: '右转',
		语言: '语言',
		预估大小: '预估大小',
		原图不能超过10MB: '原图不能超过 10MB',
		重新认证: '重新认证',
		重新填写: '重新填写',
		重置: '重置',
		左转: '左转',
	},
	城市: '城市',
	当前密码: '当前密码',
	地区: '地区',
	地址: '地址',
	地址信息: '地址信息',
	登录信息: '登录信息',
	电话号码: '电话号码',
	电话前缀: '电话前缀',
	电话前缀和手机号不能为空: '电话前缀和手机号不能为空',
	发送: '发送',
	发送验证码: '发送验证码',
	个人签名: '个性签名',
	个人资料: '个人资料',
	更换: '更换',
	更换邮箱: '更换邮箱',
	公司名称: '公司名称',
	关闭: '关闭',
	国家: '国家',
	'国家/地区': '国家/地区',
	获取验证码: '获取验证码',
	基本信息: '基本信息',
	旧密码: '旧密码',
	联系方式: '联系方式',
	密码: '密码',
	秒: '秒',
	名字: '名字',
	取消: '取消',
	'确定提交吗？': '确定提交吗？',
	确认密码: '确认密码',
	生日: '生日',
	手机号: '手机号',
	提交: '提交',
	退出登录: '退出登录',
	完成: '完成',
	未验证: '未验证',
	下一步: '下一步',
	新密码: '新密码',
	新密码不能与旧密码相同: '新密码不能与旧密码相同',
	确认密码与密码不一致: '确认密码与密码不一致',
	新邮箱地址: '新邮箱地址',
	新邮箱认证: '新邮箱认证',
	新邮箱验证码: '新邮箱验证码',
	信息认证: '信息认证',
	姓氏: '姓氏',
	性别: '性别',
	修改或完善资料: '修改或完善资料',
	验证: '验证',
	验证码: '验证码',
	已验证: '已验证',
	邮箱地址: '邮箱地址',
	'邮箱更换成功，请退出系统重新登录': '邮箱更换成功，请退出系统重新登录',
	邮箱认证: '邮箱认证',
	邮政编码: '邮政编码',
	语言: '语言',
	重复密码: '重复密码',
	重复新密码: '重复新密码',
	最后登录时间: '最后登录时间',
	最后登录IP: '最后登录IP',
}
